let React = require('react');
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

let Table = React.createClass({
    render: function () {
        return (
            <table className="table table-striped top-separator-xs">
                <TableHeader />
                <TableBody data={this.props.data}
                    tarjetas={this.props.tarjetas}
                    permissions={this.props.permissions}
                    editDate={this.props.editDate}
                    deleteDate={this.props.deleteDate} />
            </table>
        );
    }
});

export default Table